import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import MediaIndexPage from 'buyside/components/presentation/MediaIndexPage/mediaIndexPage';
import { MediaTypes } from 'buyside/components/presentation/MediaShowPage/mediaShowPage';

import { podcastEpisodeIndexUrl } from 'buyside/util/urlHelper';

const PodcastEpisodeIndexPageRoot: FC = () => {
  return (
    <ErrorBoundary pageName="the podcast episode index page">
      <Router basename={podcastEpisodeIndexUrl()}>
        <MediaIndexPage mediaType={MediaTypes.PODCAST_EPISODE} />
      </Router>
    </ErrorBoundary>
  );
};

export default PodcastEpisodeIndexPageRoot;
